import _ from 'lodash'

export const isUserOverall = () => {
  // get if user is overall
  return _.get(window, 'user.user_role', '-1').includes('overall')
}
